module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/analysis@2x-752c4c896b9a974a4c787762590c3e68.png";